﻿module Illy.SafeStack.ROP

type Result<'a, 'b> =
    | Success of 'a 
    | Failure of 'b

let succeed x = Success x
let fail x = Failure x

/// Applies a switch to success or failure
let either successFunc failureFunc twoTrackInput =
    match twoTrackInput with
    | Success s -> successFunc s
    | Failure f -> failureFunc f

/// Applies a switch function to a result
let bind switchFunction = either switchFunction fail

/// Applies a switch function to a result
let (>>=) x f = bind f x

/// Applies a switch function that expects two inputs to a result that returns a tuple
let bind2 successFunc result =
    bind (fun (x,y) -> successFunc x y) result
let (>>>=) x f = bind2 f x

/// Convert any function into a switch function
let switch f = f >> succeed

/// Convert the success result
let map f = bind (switch f)   

/// Convert the success result (infix)
let (<!>) = map

/// Convert the success result (postfix)
let (|>>) x f = f <!> x

/// Compose two switch functions
let apply f1 f2 =
    fun x ->
        f1 x >>= f2

let (>=>) = apply


/// Map both success and failure states
let doubleMap successFunc failureFunc =
    either (successFunc >> succeed) (failureFunc >> fail)

/// Combines two results, applying a double-map
let combine<'suc,'fail> (addSuccess: 'suc -> 'suc -> 'suc) (addFailure: 'fail -> 'fail -> 'fail) tt1 tt2 =
    match tt1,tt2 with
    | Success s1,Success s2 -> Success (addSuccess s1 s2)
    | Failure f1,Success _  -> Failure f1
    | Success _ ,Failure f2 -> Failure f2
    | Failure f1,Failure f2 -> Failure (addFailure f1 f2)

/// Applies two switch functions to the same input, combining the results with a double-map
let plus addSuccess addFailure switch1 switch2 x = 
    match (switch1 x),(switch2 x) with
    | Success s1,Success s2 -> Success (addSuccess s1 s2)
    | Failure f1,Success _  -> Failure f1
    | Success _ ,Failure f2 -> Failure f2
    | Failure f1,Failure f2 -> Failure (addFailure f1 f2)

/// Synonym for map
let oneTrack = map

/// Succeed unless an exception is thrown
let tryCatch f x =
    try
        f x |> Success
    with
    | ex -> Failure [ex.Message]

/// Perform a function but just pass through the input
let sideEffect f x = 
    f x |> ignore
    x